import Layout from "../Layout";

export default [
  {
    path: "/news",
    name: "newspagelayout",
    component: Layout,
  }
];
